import React, { useState, useEffect } from "react";
import { useApp } from "../context/AppContext";
import { Gift, X } from "lucide-react";

const DISMISS_KEY = "bscan_beta_banner_dismissed";

/**
 * Global "Beta gratuita" banner. Visible only when appConfig.beta_mode === true.
 * Dismissible per browser (persisted in localStorage), but re-appears after 24h.
 */
export default function BetaBanner() {
  const { appConfig, language } = useApp();
  const isEs = language === "es";
  const [hidden, setHidden] = useState(true);

  useEffect(() => {
    if (!appConfig?.beta_mode) {
      setHidden(true);
      return;
    }
    try {
      const ts = parseInt(localStorage.getItem(DISMISS_KEY) || "0", 10);
      const now = Date.now();
      // Re-show after 24h
      if (!ts || now - ts > 24 * 60 * 60 * 1000) {
        setHidden(false);
      } else {
        setHidden(true);
      }
    } catch {
      setHidden(false);
    }
  }, [appConfig?.beta_mode]);

  if (hidden || !appConfig?.beta_mode) return null;

  const dismiss = () => {
    try { localStorage.setItem(DISMISS_KEY, String(Date.now())); } catch { /* ignore */ }
    setHidden(true);
  };

  return (
    <div
      className="relative w-full bg-gradient-to-r from-[#006CFF]/15 via-[#7C3AED]/15 to-[#006CFF]/15 border-b border-[#006CFF]/25 text-white"
      data-testid="beta-banner"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2 flex items-center justify-center gap-2 text-xs sm:text-sm">
        <Gift className="w-3.5 h-3.5 text-[#FFB800] flex-shrink-0" strokeWidth={2} />
        <span className="text-white/90">
          {isEs ? (
            <>
              <strong className="text-white">Beta abierta</strong> · BScanIA es{" "}
              <strong className="text-[#00FF88]">100% gratis</strong> mientras nos ayudas a mejorarlo
            </>
          ) : (
            <>
              <strong className="text-white">Open beta</strong> · BScanIA is{" "}
              <strong className="text-[#00FF88]">100% free</strong> while you help us improve it
            </>
          )}
        </span>
        <button
          onClick={dismiss}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-white/45 hover:text-white p-1"
          aria-label="Dismiss"
          data-testid="beta-banner-dismiss"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}
